import { render, staticRenderFns } from "./Zeugnis.vue?vue&type=template&id=84e447d6&"
import script from "./Zeugnis.vue?vue&type=script&lang=js&"
export * from "./Zeugnis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports